import { PALMSUserTraining } from "collaboration-service";
import { SlideBreakpoints, myHomeLearningPathContentBreakpoints, slideBreakpoints } from "./MyHomeSettings";

export function isDone(lp: PALMSUserTraining, dateString: string) {
    return lp.trainingStatus[dateString] === "Completed";
};

export function isOverdue(lp: PALMSUserTraining, dateString: string) {
    return lp.trainingStatus[dateString] === "Overdue";
};

export function isOnTrack(lp: PALMSUserTraining, dateString: string) {
    return (lp.trainingStatus[dateString] !== "Overdue" && lp.trainingStatus[dateString] !== "Inactive")
};

export function getDateString(date: Date) {
    return date.toISOString().split('T')[0];
};

export function getEOMDate(date: Date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export function getSlideProperties(width: number): SlideBreakpoints {
    const breakpoint = slideBreakpoints.find(bp => width <= bp.breakpoint) || slideBreakpoints[slideBreakpoints.length - 1];
    return breakpoint;
}

export function getShowColumns(width: number) {
    const flags = {
        showCategory: false, //width >= myHomeLearningPathContentBreakpoints[2].width,
        showDate: width >= myHomeLearningPathContentBreakpoints[1].width,
        showProgress: width >= myHomeLearningPathContentBreakpoints[0].width,
    };
    return flags;
};
